import LatestNewsSectionList from "../components/services/LatestNewsSectionList";

const LatestNewsPage = () => {
  return (
    <LatestNewsSectionList />
  );
};
export default LatestNewsPage;
